import styled from 'styled-components';

const ErrorMessage = styled.h3`
  text-align: center;
`;

export default ErrorMessage;
